import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { PropertyPricingService } from '@app/features/pricing-and-availability';
import { NotificationType } from '@app/shared/interfaces';
import { PropertiesService } from '@app/shared/services/properties/properties.service';
import { TitleService } from '@app/shared/services/title/title.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { map } from 'rxjs';
import { PropertyDetailSubnavComponent } from '../../components/property-detail-subnav/property-detail-subnav.component';

@Component({
  standalone: false,
  selector: 'sbnb-property-detail',
  templateUrl: './property-detail.component.html',
  styleUrls: ['./property-detail.component.scss'],
  providers: [PropertyPricingService],
})
export class PropertyDetailComponent implements OnInit {
  property: any;
  propertyId: any;
  loading: boolean;
  saveStatus: number;
  onboardingStatus: boolean;

  private _activeNavItem = 'merge-match';

  public properties$ = this.propertyService
    .getProperties({
      filterCriteria: [],
      paginate: false,
      transformer: 'simple',
    })
    .pipe(map((res) => res.data));

  public get activeNavItem() {
    return this._activeNavItem;
  }

  public set activeNavItem(newItem: string) {
    this._activeNavItem = newItem;

    if (newItem === 'calendar') {
      this.router.navigate([`/calendar/property/${this.property.id}`], { queryParams: { source: 'p' } });
      return;
    }

    // Two way bind the router
    const url = this.router.createUrlTree(['/properties/property/', this.propertyId, newItem]).toString();

    this.router.navigate([url]);
  }

  public activeHeading: string;

  setActiveComponent({ path, heading }: { path: string; heading: string }) {
    this.activeNavItem = path;
    this.activeHeading = heading;
  }

  @ViewChild('propertyDetailSubnavComponent')
  propertyDetailSubnavComponent: PropertyDetailSubnavComponent;

  constructor(
    private propertyService: PropertiesService,
    private route: ActivatedRoute,
    private titleService: TitleService,
    private router: Router,
    private toast: ToastNotificationsService,
    public permissionsService: UserPermissionsService
  ) {}

  ngOnInit() {
    this.initialize();
  }

  private initialize() {
    this.loading = true;

    this.route.paramMap.subscribe((params) => {
      this.propertyId = params.get('id');

      if (params.has('area') && this.activeNavItem !== params.get('area')) {
        this.activeNavItem = params.get('area');
      }

      this.propertyService.getProperty(this.propertyId, ['can_manage_availability']).subscribe((res) => {
        if (res.error || !res.id) {
          this.toast.open('Failed to load property.', 'Dismiss', NotificationType.Error);

          this.router.navigate(['/properties']);
          return;
        }
        this.property = res;
        this.titleService.manuallySet(this.property.name);
        this.loading = false;
      });
    });
  }

  updateProperty() {
    this.saveStatus = 1;

    this.propertyService.updateProperty(this.propertyId, this.property).subscribe((res) => {
      if (res.error) {
        this.saveStatus = -1;
      } else {
        this.saveStatus = 2;
      }
    });
  }

  onboardingChange(onboardingStatus: boolean) {
    this.onboardingStatus = onboardingStatus;
  }

  public propertyChanged(propertyId: number) {
    const url = this.router.url.split('/');
    const currentPath = url[url.length - 1];
    this.router.navigate([`/properties/property/${propertyId}`, currentPath]).then(() => {
      this.initialize();
    });
  }
}
